import { FC } from 'react';
import { PageTitle, SectionTitle, SectionContent, SectionsList } from '../styles';

export const PrivacyPolicyEng: FC = () => {
  return (
    <>
      <PageTitle>Privacy and personal data processing policy</PageTitle>
      <SectionsList>
        <li>
          <SectionTitle>General Provisions. Parties. Legal purpose of the document.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            1.1. This Policy determines the procedure and conditions according to&nbsp;which The Administrator 
            of&nbsp;the Platform, as&nbsp;defined in&nbsp;the Public Offer on&nbsp;the terms of&nbsp;use of&nbsp;the 
            Platform, available&nbsp;at: <a href='https://deziiign.ru/legals/offer'>https://deziiign.ru/legals/offer</a> (&laquo;We&raquo; or&nbsp;&laquo;Administrator&raquo;) shall 
            process the information about an&nbsp;individual that can be&nbsp;obtained by&nbsp;the Administrator from this individual 
            or&nbsp;from a&nbsp;legal representative (&laquo;You&raquo; or&nbsp;&laquo;User&raquo;), in&nbsp;the event of&nbsp;the 
            following relationships with the User:
            <ul>
              <li>
                when the User is using the functions of the Digital Platform
                (&quot;Platform&quot;), including the websites{' '}
                <a href="https://deziiign.ru">https://deziiign.ru</a>, <a
                href="https://deziiign.com">https://deziiign.com</a>, (<a
                href="https://deziiign.com/school">https://deziiign.com/school</a> is excluded), <a
                href="https://gallllery.com">https://gallllery.com</a>, <a
                href="https://geograffee.ru">https://geograffee.ru</a>, <a
                href="https://geograffee.com">https://geograffee.com</a>, <a
                href="https://kitkot.com">https://kitkot.com</a>, <a href="https://artz.work">https://artz.work</a>, <a
                href="https://onlinesworld.ru">https://onlinesworld.ru</a>, <a
                href="https://brnd.ru">https://brnd.ru</a>, all of its domains,
                subdomains and pages (&quot;Site&quot;), software offered by the Administrator on this
                Site or on the resources of third parties, including computer programs, mobile
                applications, API interfaces and API systems, widgets. The use of the Platform is
                carried out in accordance with the Public Offer on the terms of use of the Burgundy
                Digital Platform, available at:{' '}
                <a href='https://deziiign.ru/legals/offer'>
                  https://deziiign.ru/legals/offer
                </a>
              </li>
              <li>
                when the Administrator arises and fulfills obligations, any agreements and contracts
                concluded with the User;
              </li>
              <li>
                when processing requests, complaints, inquiries, messages sent by the Administrator and
                the User to each other;
              </li>
            </ul>
            <p>
              1.2. The legal purpose of this Policy is to ensure the proper legal procedure for personal
              information, which may include personal data.
            </p>
            <p>
              1.3. The legal ground for processing personal information shall consist of the following:
              <ul>
                <li>the User’s consent to the processing of personal data;</li>
                <li>the Administrator&apos;s charter;</li>
                <li>
                  laws and normative legal acts adopted on their basis governing information relations and information
                  technologies;
                </li>
                <li>
                  agreements concluded between the Administrator and the User;
                </li>
                <li>
                  the European General Data Protection Regulation (“GDPR” or “(EU) 2016/679”) when the
                  Parties’ legal relationship falls under the exterritorial criteria of it.
                </li>
              </ul>
            </p>
            <p>
              1.4. By using any functions of the Platform or entering into a relationship with the
              Administrator provided for in clause 1.1. the User fully agrees with the terms of this
              Policy. In case of disagreement with the terms of this Policy, the use of the Platform or
              the performance of actions within the framework of relationship provided for in clause 1.1.
              must be immediately terminated.
            </p>
            <p>
              1.5 If the User performs registration/authorization using an account of another resource that the User
              already has
              (“Login using…” option), then the rules for the relationship between the User and the administrator of
              such an
              account (third party) are governed by user agreements, privacy policies or other documents concluded
              between the
              User and such account administrator (third party). The Administrator does not carry out any processing of
              the data
              of the User's account provided to the User by a third party, including the processing of personal data
              that may be
              contained in the User's account provided by a third party: all and any specified operations with the data
              of such a
              User are carried out by such a third party.
            </p>
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Rules for the collection and processing of personal information.</SectionTitle>
        </li>
        <SectionContent>
          <p className="bold">2.1. The purpose of collecting and processing personal information.</p>
          <p>
            2.1.1. The Administrator processes personal information for the following purposes (together -
            &quot;Purpose of processing&quot;):
            <ul>
              <li>
                to&nbsp;identify a&nbsp;party under agreements and contracts, to&nbsp;fulfill
                contractual obligations to&nbsp;the User, including ensuring the functions of&nbsp;the
                Platform;
              </li>
              <li>
                to comply with the requirements of the current legislation (including in order to prevent or suppress
                harmful or
                illegal actions of the User or third parties);
              </li>
              <li>
                to&nbsp;communicate with the User, send messages, notifications, requests, responses,
                documents on&nbsp;payments and settlements, documents of&nbsp;legal significance
                to&nbsp;the User;
              </li>
              <li>
                to&nbsp;send to&nbsp;the User messages of&nbsp;advertising or&nbsp;informing nature,
                always taking into account the restrictions of&nbsp;the relevant section of&nbsp;the
                Policy;
              </li>
              <li>
                to&nbsp;check, research and analyze data to&nbsp;maintain and improve the functions
                of&nbsp;the Platform, as&nbsp;well as&nbsp;to&nbsp;develop new functions;
              </li>
              <li>to&nbsp;conduct statistical and other studies based on&nbsp;anonymized data;</li>
              <li>
                to&nbsp;invite the User to&nbsp;visit other sites and other web resources of&nbsp;the
                Administrator or&nbsp;third parties, to&nbsp;offer products of&nbsp;the Administrator
                or&nbsp;third parties that, in&nbsp;the Administrator&rsquo;s opinion, may interest the
                User (that&nbsp;is, to&nbsp;show the User advertising that takes his interests into
                account);
              </li>
              <li>
                in&nbsp;order to&nbsp;protect the rights of&nbsp;the Parties or&nbsp;the rights
                of&nbsp;third parties.
              </li>
            </ul>
          </p>
          <p>
            2.1.2. The processing of personal information, including personal data, will be limited to the
            achievement of these specific, predetermined and legitimate purposes. Processing of personal
            data that is incompatible with the stated purposes is not allowed.
          </p>
          <p className="bold">2.2. Personal data subjects. Volumes and categories of information.</p>
          <p>
            2.2.1. The subject of personal data is:
            <ul>
              <li>
                an individual who has transferred his or her personal data to the Administrator on his
                own;
              </li>
              <li>
                a legal representative of an individual, if the data was transferred by such a
                representative;
              </li>
              <li>individuals - representatives and employees of legal entities.</li>
            </ul>
          </p>
          <p>
            2.2.2. For each category of the subjects, the personal information includes the following data,
            collected and processed as follows:
            <ul>
              <li>
                <span className="bold">Data provided by the User on his or her own actions</span> while using the
                functions of the Platform: name, family name,
                e-mail address;
              </li>
              <li>
                                <span className="bold">
                                    Data that is automatically transmitted to the Administrator&apos;s hardware
                                </span>{' '}
                during connection with the software installed
                on the User's device: IP address, cookie information, information about the user's browser (or other
                program through
                which access is provided), information about hardware and software, data of a wi-fi or wired network,
                date and time
                of access, addresses and content of requests, http/https headers, web beacons and pixel tags;
              </li>
              <li>
                <span className="bold">Information about activity during the use of the Platform:</span>{' '}
                history of actions, data on visited pages or sections, likes and preferences, other
                interaction with the interface of the Platform;
              </li>
              <li>
                <span className="bold">Geolocation data</span>
                (information on location of the User&apos;s devices), if the User has allowed the
                devices to provide it;
              </li>
            </ul>
          </p>
          <p>
            2.2.3. <span className="bold">On special (vulnerable) categories of personal data:</span> The Administrator
            does not collect or process data related to
            special (vulnerable) categories of personal data, including data on racial and national origin, political
            and
            religious views, gender self-identity, health, biometric data and the like.
          </p>
          <p className="bold">2.3. The procedure and conditions for the processing of personal data.</p>
          <p>
            2.3.1. Processing of personal data - any action (operation) or a set of actions (operations)
            with personal data performed with the use of automation tools or without their use. When
            processing personal data, the Administrator will carry out the following actions: collection;
            recording; systematization; accumulation; storage; clarification (update, change); extraction;
            usage; transmission (distribution, provision, access); depersonalization; blocking; deletion;
            destruction.
          </p>
          <p>
            2.3.2. The administrator can process personal information in the determined above ways
            (operations) both in personal data information systems and without using automation tools.
          </p>
          <p>
            2.3.3. The Administrator will process the User&apos;s personal information for as long as
            necessary to achieve the specific purpose for which it was collected, or to comply with legal
            requirements.
          </p>
          <p>
            2.3.4. In the event that the User withdraws consent allowing processing of personal data or the
            expiration of such consent, the Administrator has the right to block this data from editing and
            process it in archived form for 3 (three) years.
          </p>
          <p className="bold">2.4. Data protection measures.</p>
          <p>
            2.4.1. The Administrator takes all necessary measures to protect the User&apos;s personal data
            from unauthorized, accidental or illegal destruction, loss, alteration, unfair use, disclosure
            or access, as well as other illegal forms of processing.
          </p>
          <p>
            2.4.2. By default, personal information is processed by automatic equipment without anyone
            having access to it. If such access is required, the Administrator provides access to the
            User&apos;s personal data only to those persons who need this information to ensure the Purpose
            of processing. To protect and ensure the confidentiality of data, such persons must undertake to
            comply with internal legal rules and procedures, state legislation, technical and organizational
            security measures in relation to the processing of personal information.
          </p>
          <p>
            2.4.3. Both in the processing of personal data without the use of automation tools, and in
            automated processing, sufficient security of the place where the processing of personal data
            takes place is ensured.
          </p>
          <p>
            2.4.4. The disclosure of the information provided by the User can be made only in accordance with the
            current legislation
            at the request of the court, law enforcement agencies, and in other cases stipulated by the legislation.
          </p>
          <p>
            2.4.5. The Administrator does not verify the accuracy of the information provided by the User, and proceeds
            from the fact
            that the User, in accordance with the principle of good faith provides reliable and sufficient information,
            takes
            care of the timeliness of making changes to previously provided information, updates the information.
          </p>
          <p className="bold">2.5. Rules on the transfer of personal information to third parties.</p>
          <p>
            2.5.1. The administrator has the right to transfer personal information to the following third
            parties:
            <ul>
              <li>
                to the recipient of assigned (transferred) rights or obligations, or to the subject of
                novation under the relevant agreement (for example, in cases of legal succession or
                selling the business as a whole or a part of the business);
              </li>
              <li>
                to any national or international regulatory authority, law enforcement agency, central
                or local government, other official or state agency or court to which the Administrator
                is required to provide information upon request in accordance with applicable law;
              </li>
              <li>
                if the User himself has consented to the transfer of personal information to a third
                party, or the transfer of personal information is required to provide a certain function
                of the Platform or to fulfill a certain agreement or contract concluded with the User;
              </li>
              <li>
                in order to ensure legal protection of the Administrator or third parties in case of
                violation of their rights or a threat of violation of their rights, including violation
                of laws or other regulatory documents.
              </li>
            </ul>
          </p>
          <p>
            2.5.2. The User has the right to allow and forbid free distribution of categories of personal
            information by applying visibility settings in his or her account.
          </p>
          <p className="bold">
            2.6. Rights and obligations in relation to personal information. The Representative.
          </p>
          <p>
            2.6.1. The user is obliged to take care of the accuracy of the information provided, the
            timeliness of making changes to the information provided, its updating, otherwise the
            Administrator is not responsible for default, any damages, harm or loss.
          </p>
          <p>
            2.6.2. <span className="bold">On representatives:</span> The User has the right to authorize,
            restrict or prohibit the processing of personal data of third parties only on the basis of a
            representation established by law (for example, parents and guardians) or by a transaction of
            rights (for example, a power of attorney), which gives him the right to authorize the processing
            of personal information for a third party and bear other rights and obligations in the interests
            of such a third party. If the User does not have the right to give such permission or has lost
            the right to give such permission, then he must refrain from data transferring or stop data
            transferring (and delete previously transferred data), respectively, and in the event of
            relevant claims, he undertakes to independently resolve the contradictions and release the
            Administrator from such claims. In case of non-compliance with these requirements, the User is
            obliged to reimburse the Administrator for all losses caused by non-compliance with these
            requirements.
          </p>
          <p className="bold">
            2.7. Updating, correcting, blocking and deleting personal data, the response procedure to Your
            request for accessing Your personal data.
          </p>
          <p>
            2.7.1. The User can update and correct personal information using the appropriate functions of
            his account, and if the functions of the account are not sufficient in the opinion of the User -
            by sending a written request to the Administrator&apos;s email address specified in this Policy.
          </p>
          <p>
            2.7.2. The User can block and delete personal information using the appropriate functions of his
            account, and if the functions of the account are not sufficient in the opinion of the User - by
            sending a written request to the Administrator&apos;s email address specified in this Policy.
          </p>
          <p>
            2.7.3. Other rights of the subject of personal data are exercised in a similar manner: to
            exercise the right, the User can use the appropriate functions of his account, and if the
            functions of the account are not sufficient in the opinion of the User, by sending a written
            request to the Administrator&apos;s e-mail address specified in this Policy.
          </p>
          <p className="bold">
            2.7.4. The User has the right to:
            <ul>
              <li>request information about the processing of&nbsp;personal data in&nbsp;progress;</li>
              <li>withdraw consent to&nbsp;the processing of&nbsp;personal information;</li>
              <li>demand restrictions on&nbsp;the processing of&nbsp;personal information;</li>
              <li>
                request to&nbsp;stop processing personal information, if&nbsp;provided
                by&nbsp;applicable law and this Policy.
              </li>
            </ul>
          </p>
          <p>
            2.7.5. In cases provided for by applicable law, the User may also have other rights not
            specified above.
          </p>
          <p>
            2.7.6. The user undertakes to use the contact information (party’s details) from this Policy to
            send requests for the exercise of the rights of the subject of personal data or complaints
            regarding the incorrectness of information or the illegality of its processing. Such requests
            and complaints are considered within a period not exceeding 30 (Thirty) calendar days from the
            date of receipt by the Administrator.
          </p>
          <p>
            2.7.7. If the User is not satisfied with the results of consideration of the request or
            complaint, then he has the right to submit a request or complaint to the government body
            authorized to protect the rights of subjects of personal data.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Notices and communication of the Parties.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            3.1. The User agrees to receive messages from the Administrator by e-mail and by the phone
            number specified by the User when using the functions of the Platform (hereinafter referred to
            as &quot;Notifications&quot;).
          </p>
          <p>
            3.2. The user has the right to revoke his consent to receive the Notifications:
            <ul>
              <li>by clicking on the &quot;Unsubscribe&quot; link at the bottom of the letter;</li>
              <li>by sending a notification to the Administrator&apos;s e-mail.</li>
            </ul>
          </p>
          <p>
            3.3. The User agrees that the Administrator stops sending the Notifications not earlier than 24
            hours after the performance of these actions.
          </p>
          <p>
            The administrator has the right to use the Notifications for:
            <ul>
              <li>informing the User about the operation of the Platform functions;</li>
              <li>informing the User about changes in regulatory documents;</li>
              <li>sending messages and mailings of informational character to the User;</li>
              <li>sending messages and mailings of an advertising nature to the User.</li>
            </ul>
          </p>
          <p>
            3.5. The User, in turn, undertakes to send all messages, notifications, statements and documents
            (including messages that represent responses to Notifications) to the Administrator&apos;s email
            address specified in this Policy.
          </p>
          <p>
            3.6. The Administrator has the right to request any document that, in the opinion of the
            Administrator, has legal significance, in its paper form. Such documents, as well as documents
            that the User himself considers necessary to send in paper form, are sent to the address of the
            Administrator&apos;s location specified in this Policy.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Changes to the Privacy Policy. Applicable Law.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            4.1. The administrator has the right to make changes to this Policy. When making changes, the date of the
            last update is
            indicated in the text of the current edition. The new edition of the Policy comes into legal effect from the
            moment
            it is posted, unless otherwise provided by the new edition of the Policy. Expired editions are available in
            the
            web-archive at the address specified in the Policy.
          </p>
          <p>
            4.2. Both expression of&nbsp;consent with this Policy and execution of&nbsp;this Policy shall be&nbsp;always considered happening 
            at&nbsp;the location of&nbsp;the Administrator, and the law applicable to&nbsp;the relationship between the Administrator and the User 
            is&nbsp;always the law of&nbsp;the location of&nbsp;the Administrator, regardless of&nbsp;where the User or&nbsp;the equipment used 
            by&nbsp;him or&nbsp;her is&nbsp;located. All disputes and disagreements are resolved at&nbsp;the location of&nbsp;the Administrator. 
            The exception is&nbsp;when the Parties&rsquo; legal relationship falls under the exterritorial criteria of&nbsp;the European General 
            Data Protection Regulation (&laquo;GDPR&raquo; or&nbsp;&laquo;(EU) 2016/679&raquo;). In&nbsp;such case, the law applicable to&nbsp;the 
            relationship between the Administrator and the User shall consist jointly of&nbsp;the law of&nbsp;the location of&nbsp;the Administrator 
            and the rules of&nbsp;the GDPR regulation, including the rules of&nbsp;solving disputes and disagreements between the participants 
            of&nbsp;personal data processing.
          </p>
          <p>
            4.3. The Policy begins to regulate the relationship between the User and the Administrator from the moment
            the User
            expresses consent to its terms and conditions and is valid indefinitely. The indefinite validity of the
            Policy as a
            document does not in any way mean the indefiniteness/absence of restrictions on the period for processing
            personal
            data. Unilateral termination of the Policy by the will of one of the Parties is not allowed.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Rules for Users located in the European Union.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            5.1. In case You have allowed Your equipment to provide geolocation data, and from the contents
            of this data We can determine Your location within the European Union (EU), We are obliged to
            provide You with additional rights and guarantees in accordance with the European General Data
            Protection Regulation (&quot;GDPR&quot; or &quot;(EU) 2016/679&quot;), if the legal relationship
            of the Parties falls within its extraterritorial criteria.
          </p>
          <p>
            5.2. The User hereby acknowledges that the location of the User’s equipment that is transferring
            data to the Administrator shall be the only technically possible way to identify the User as an
            EU resident. If the User is using any means to cloak his or her location, or is using any means
            which may possibly cause such a cloaking, then the Administrator is not able to identify the
            User as a Party falling under the regulation of GDPR and therefore the relationship between the
            User and the Administrator shall not be liable to GDPR regulation.
          </p>
          <p>
            5.3. The relationship between the User and the Administrator shall fall under the GDPR
            regulation from the moment We identify Your location inside the EU and up to the moment We
            identify Your new location outside the EU.
          </p>
          <p>
            5.4. The core rights and guarantees of GDPR for individuals are the following:
            <ul>
              <li>the right to&nbsp;be&nbsp;informed;</li>
              <li>the right of&nbsp;access;</li>
              <li>the right to&nbsp;rectification;</li>
              <li>the right to&nbsp;erasure;</li>
              <li>the right to&nbsp;restrict processing;</li>
              <li>the right to&nbsp;data portability;</li>
              <li>the right to&nbsp;object;</li>
              <li>the rights related to&nbsp;automated decision making (including profiling).</li>
            </ul>
          </p>
          <p>
            5.5. In cases provided for by applicable law, the User may also have other rights and guarantees
            not specified above.
          </p>
          <p>
            5.6. To exercise the rights and guarantees, the User can use the appropriate functions of his
            account, and if the functions of the account are not sufficient in the opinion of the User, by
            sending a written request to the Administrator&apos;s e-mail address specified in this Policy.
          </p>
          <p>
            5.7. Should the Administrator use any kind of third-party data processor service to process
            personal data, he shall provide the data processor’s full compliance with GDPR and shall provide
            You with the requested information concerning such data processor.
          </p>
          <p>
            5.8. The User is fully aware and accepts the fact that the extension of GDPR rules to the
            relations of the Parties does not in any way entail and does not indicate the application of any
            other acts of European Union legislation to the relations of the Parties.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Edition information.</SectionTitle>
        </li>
        <SectionContent>
          <p>This edition of the document was published on: 2025, May, 5st</p>
        </SectionContent>
      </SectionsList>
    </>
  );
};
import { FC } from 'react';
import { PageTitle, SectionTitle, SectionContent, SectionsList } from '../styles';

export const PrivacyPolicyEng: FC = () => {
  return (
    <>
      <PageTitle>Privacy and personal data processing policy</PageTitle>
      <SectionsList>
        <li>
          <SectionTitle>General Provisions. Parties. Legal purpose of the document.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            1.1. This Policy determines the procedure and conditions according to&nbsp;which The Administrator 
            of&nbsp;the Platform, as&nbsp;defined in&nbsp;the Public Offer on&nbsp;the terms of&nbsp;use of&nbsp;the 
            Platform, available&nbsp;at: <a href='https://deziiign.ru/legals/offer'>https://deziiign.ru/legals/offer</a> (&laquo;We&raquo; or&nbsp;&laquo;Administrator&raquo;) shall 
            process the information about an&nbsp;individual that can be&nbsp;obtained by&nbsp;the Administrator from this individual 
            or&nbsp;from a&nbsp;legal representative (&laquo;You&raquo; or&nbsp;&laquo;User&raquo;), in&nbsp;the event of&nbsp;the 
            following relationships with the User:
            <ul>
              <li>
                when the User is using the functions of the Digital Platform
                (&quot;Platform&quot;), including the websites{' '}
                <a href="https://deziiign.ru">https://deziiign.ru</a>, <a
                href="https://deziiign.com">https://deziiign.com</a>, (<a
                href="https://deziiign.com/school">https://deziiign.com/school</a> is excluded), <a
                href="https://gallllery.com">https://gallllery.com</a>, <a
                href="https://geograffee.ru">https://geograffee.ru</a>, <a
                href="https://geograffee.com">https://geograffee.com</a>, <a
                href="https://kitkot.com">https://kitkot.com</a>, <a href="https://artz.work">https://artz.work</a>, <a
                href="https://onlinesworld.ru">https://onlinesworld.ru</a>, <a
                href="https://brnd.ru">https://brnd.ru</a>, all of its domains,
                subdomains and pages (&quot;Site&quot;), software offered by the Administrator on this
                Site or on the resources of third parties, including computer programs, mobile
                applications, API interfaces and API systems, widgets. The use of the Platform is
                carried out in accordance with the Public Offer on the terms of use of the Burgundy
                Digital Platform, available at:{' '}
                <a href='https://deziiign.ru/legals/offer'>
                  https://deziiign.ru/legals/offer
                </a>
              </li>
              <li>
                when the Administrator arises and fulfills obligations, any agreements and contracts
                concluded with the User;
              </li>
              <li>
                when processing requests, complaints, inquiries, messages sent by the Administrator and
                the User to each other;
              </li>
            </ul>
            <p>
              1.2. The legal purpose of this Policy is to ensure the proper legal procedure for personal
              information, which may include personal data.
            </p>
            <p>
              1.3. The legal ground for processing personal information shall consist of the following:
              <ul>
                <li>the User’s consent to the processing of personal data;</li>
                <li>the Administrator&apos;s charter;</li>
                <li>
                  laws and normative legal acts adopted on their basis governing information relations and information
                  technologies;
                </li>
                <li>
                  agreements concluded between the Administrator and the User;
                </li>
                <li>
                  the European General Data Protection Regulation (“GDPR” or “(EU) 2016/679”) when the
                  Parties’ legal relationship falls under the exterritorial criteria of it.
                </li>
              </ul>
            </p>
            <p>
              1.4. By using any functions of the Platform or entering into a relationship with the
              Administrator provided for in clause 1.1. the User fully agrees with the terms of this
              Policy. In case of disagreement with the terms of this Policy, the use of the Platform or
              the performance of actions within the framework of relationship provided for in clause 1.1.
              must be immediately terminated.
            </p>
            <p>
              1.5 If the User performs registration/authorization using an account of another resource that the User
              already has
              (“Login using…” option), then the rules for the relationship between the User and the administrator of
              such an
              account (third party) are governed by user agreements, privacy policies or other documents concluded
              between the
              User and such account administrator (third party). The Administrator does not carry out any processing of
              the data
              of the User's account provided to the User by a third party, including the processing of personal data
              that may be
              contained in the User's account provided by a third party: all and any specified operations with the data
              of such a
              User are carried out by such a third party.
            </p>
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Rules for the collection and processing of personal information.</SectionTitle>
        </li>
        <SectionContent>
          <p className="bold">2.1. The purpose of collecting and processing personal information.</p>
          <p>
            2.1.1. The Administrator processes personal information for the following purposes (together -
            &quot;Purpose of processing&quot;):
            <ul>
              <li>
                to&nbsp;identify a&nbsp;party under agreements and contracts, to&nbsp;fulfill
                contractual obligations to&nbsp;the User, including ensuring the functions of&nbsp;the
                Platform;
              </li>
              <li>
                to comply with the requirements of the current legislation (including in order to prevent or suppress
                harmful or
                illegal actions of the User or third parties);
              </li>
              <li>
                to&nbsp;communicate with the User, send messages, notifications, requests, responses,
                documents on&nbsp;payments and settlements, documents of&nbsp;legal significance
                to&nbsp;the User;
              </li>
              <li>
                to&nbsp;send to&nbsp;the User messages of&nbsp;advertising or&nbsp;informing nature,
                always taking into account the restrictions of&nbsp;the relevant section of&nbsp;the
                Policy;
              </li>
              <li>
                to&nbsp;check, research and analyze data to&nbsp;maintain and improve the functions
                of&nbsp;the Platform, as&nbsp;well as&nbsp;to&nbsp;develop new functions;
              </li>
              <li>to&nbsp;conduct statistical and other studies based on&nbsp;anonymized data;</li>
              <li>
                to&nbsp;invite the User to&nbsp;visit other sites and other web resources of&nbsp;the
                Administrator or&nbsp;third parties, to&nbsp;offer products of&nbsp;the Administrator
                or&nbsp;third parties that, in&nbsp;the Administrator&rsquo;s opinion, may interest the
                User (that&nbsp;is, to&nbsp;show the User advertising that takes his interests into
                account);
              </li>
              <li>
                in&nbsp;order to&nbsp;protect the rights of&nbsp;the Parties or&nbsp;the rights
                of&nbsp;third parties.
              </li>
            </ul>
          </p>
          <p>
            2.1.2. The processing of personal information, including personal data, will be limited to the
            achievement of these specific, predetermined and legitimate purposes. Processing of personal
            data that is incompatible with the stated purposes is not allowed.
          </p>
          <p className="bold">2.2. Personal data subjects. Volumes and categories of information.</p>
          <p>
            2.2.1. The subject of personal data is:
            <ul>
              <li>
                an individual who has transferred his or her personal data to the Administrator on his
                own;
              </li>
              <li>
                a legal representative of an individual, if the data was transferred by such a
                representative;
              </li>
              <li>individuals - representatives and employees of legal entities.</li>
            </ul>
          </p>
          <p>
            2.2.2. For each category of the subjects, the personal information includes the following data,
            collected and processed as follows:
            <ul>
              <li>
                <span className="bold">Data provided by the User on his or her own actions</span> while using the
                functions of the Platform: name, family name,
                e-mail address;
              </li>
              <li>
                                <span className="bold">
                                    Data that is automatically transmitted to the Administrator&apos;s hardware
                                </span>{' '}
                during connection with the software installed
                on the User's device: IP address, cookie information, information about the user's browser (or other
                program through
                which access is provided), information about hardware and software, data of a wi-fi or wired network,
                date and time
                of access, addresses and content of requests, http/https headers, web beacons and pixel tags;
              </li>
              <li>
                <span className="bold">Information about activity during the use of the Platform:</span>{' '}
                history of actions, data on visited pages or sections, likes and preferences, other
                interaction with the interface of the Platform;
              </li>
              <li>
                <span className="bold">Geolocation data</span>
                (information on location of the User&apos;s devices), if the User has allowed the
                devices to provide it;
              </li>
            </ul>
          </p>
          <p>
            2.2.3. <span className="bold">On special (vulnerable) categories of personal data:</span> The Administrator
            does not collect or process data related to
            special (vulnerable) categories of personal data, including data on racial and national origin, political
            and
            religious views, gender self-identity, health, biometric data and the like.
          </p>
          <p className="bold">2.3. The procedure and conditions for the processing of personal data.</p>
          <p>
            2.3.1. Processing of personal data - any action (operation) or a set of actions (operations)
            with personal data performed with the use of automation tools or without their use. When
            processing personal data, the Administrator will carry out the following actions: collection;
            recording; systematization; accumulation; storage; clarification (update, change); extraction;
            usage; transmission (distribution, provision, access); depersonalization; blocking; deletion;
            destruction.
          </p>
          <p>
            2.3.2. The administrator can process personal information in the determined above ways
            (operations) both in personal data information systems and without using automation tools.
          </p>
          <p>
            2.3.3. The Administrator will process the User&apos;s personal information for as long as
            necessary to achieve the specific purpose for which it was collected, or to comply with legal
            requirements.
          </p>
          <p>
            2.3.4. In the event that the User withdraws consent allowing processing of personal data or the
            expiration of such consent, the Administrator has the right to block this data from editing and
            process it in archived form for 3 (three) years.
          </p>
          <p className="bold">2.4. Data protection measures.</p>
          <p>
            2.4.1. The Administrator takes all necessary measures to protect the User&apos;s personal data
            from unauthorized, accidental or illegal destruction, loss, alteration, unfair use, disclosure
            or access, as well as other illegal forms of processing.
          </p>
          <p>
            2.4.2. By default, personal information is processed by automatic equipment without anyone
            having access to it. If such access is required, the Administrator provides access to the
            User&apos;s personal data only to those persons who need this information to ensure the Purpose
            of processing. To protect and ensure the confidentiality of data, such persons must undertake to
            comply with internal legal rules and procedures, state legislation, technical and organizational
            security measures in relation to the processing of personal information.
          </p>
          <p>
            2.4.3. Both in the processing of personal data without the use of automation tools, and in
            automated processing, sufficient security of the place where the processing of personal data
            takes place is ensured.
          </p>
          <p>
            2.4.4. The disclosure of the information provided by the User can be made only in accordance with the
            current legislation
            at the request of the court, law enforcement agencies, and in other cases stipulated by the legislation.
          </p>
          <p>
            2.4.5. The Administrator does not verify the accuracy of the information provided by the User, and proceeds
            from the fact
            that the User, in accordance with the principle of good faith provides reliable and sufficient information,
            takes
            care of the timeliness of making changes to previously provided information, updates the information.
          </p>
          <p className="bold">2.5. Rules on the transfer of personal information to third parties.</p>
          <p>
            2.5.1. The administrator has the right to transfer personal information to the following third
            parties:
            <ul>
              <li>
                to the recipient of assigned (transferred) rights or obligations, or to the subject of
                novation under the relevant agreement (for example, in cases of legal succession or
                selling the business as a whole or a part of the business);
              </li>
              <li>
                to any national or international regulatory authority, law enforcement agency, central
                or local government, other official or state agency or court to which the Administrator
                is required to provide information upon request in accordance with applicable law;
              </li>
              <li>
                if the User himself has consented to the transfer of personal information to a third
                party, or the transfer of personal information is required to provide a certain function
                of the Platform or to fulfill a certain agreement or contract concluded with the User;
              </li>
              <li>
                in order to ensure legal protection of the Administrator or third parties in case of
                violation of their rights or a threat of violation of their rights, including violation
                of laws or other regulatory documents.
              </li>
            </ul>
          </p>
          <p>
            2.5.2. The User has the right to allow and forbid free distribution of categories of personal
            information by applying visibility settings in his or her account.
          </p>
          <p className="bold">
            2.6. Rights and obligations in relation to personal information. The Representative.
          </p>
          <p>
            2.6.1. The user is obliged to take care of the accuracy of the information provided, the
            timeliness of making changes to the information provided, its updating, otherwise the
            Administrator is not responsible for default, any damages, harm or loss.
          </p>
          <p>
            2.6.2. <span className="bold">On representatives:</span> The User has the right to authorize,
            restrict or prohibit the processing of personal data of third parties only on the basis of a
            representation established by law (for example, parents and guardians) or by a transaction of
            rights (for example, a power of attorney), which gives him the right to authorize the processing
            of personal information for a third party and bear other rights and obligations in the interests
            of such a third party. If the User does not have the right to give such permission or has lost
            the right to give such permission, then he must refrain from data transferring or stop data
            transferring (and delete previously transferred data), respectively, and in the event of
            relevant claims, he undertakes to independently resolve the contradictions and release the
            Administrator from such claims. In case of non-compliance with these requirements, the User is
            obliged to reimburse the Administrator for all losses caused by non-compliance with these
            requirements.
          </p>
          <p className="bold">
            2.7. Updating, correcting, blocking and deleting personal data, the response procedure to Your
            request for accessing Your personal data.
          </p>
          <p>
            2.7.1. The User can update and correct personal information using the appropriate functions of
            his account, and if the functions of the account are not sufficient in the opinion of the User -
            by sending a written request to the Administrator&apos;s email address specified in this Policy.
          </p>
          <p>
            2.7.2. The User can block and delete personal information using the appropriate functions of his
            account, and if the functions of the account are not sufficient in the opinion of the User - by
            sending a written request to the Administrator&apos;s email address specified in this Policy.
          </p>
          <p>
            2.7.3. Other rights of the subject of personal data are exercised in a similar manner: to
            exercise the right, the User can use the appropriate functions of his account, and if the
            functions of the account are not sufficient in the opinion of the User, by sending a written
            request to the Administrator&apos;s e-mail address specified in this Policy.
          </p>
          <p className="bold">
            2.7.4. The User has the right to:
            <ul>
              <li>request information about the processing of&nbsp;personal data in&nbsp;progress;</li>
              <li>withdraw consent to&nbsp;the processing of&nbsp;personal information;</li>
              <li>demand restrictions on&nbsp;the processing of&nbsp;personal information;</li>
              <li>
                request to&nbsp;stop processing personal information, if&nbsp;provided
                by&nbsp;applicable law and this Policy.
              </li>
            </ul>
          </p>
          <p>
            2.7.5. In cases provided for by applicable law, the User may also have other rights not
            specified above.
          </p>
          <p>
            2.7.6. The user undertakes to use the contact information (party’s details) from this Policy to
            send requests for the exercise of the rights of the subject of personal data or complaints
            regarding the incorrectness of information or the illegality of its processing. Such requests
            and complaints are considered within a period not exceeding 30 (Thirty) calendar days from the
            date of receipt by the Administrator.
          </p>
          <p>
            2.7.7. If the User is not satisfied with the results of consideration of the request or
            complaint, then he has the right to submit a request or complaint to the government body
            authorized to protect the rights of subjects of personal data.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Notices and communication of the Parties.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            3.1. The User agrees to receive messages from the Administrator by e-mail and by the phone
            number specified by the User when using the functions of the Platform (hereinafter referred to
            as &quot;Notifications&quot;).
          </p>
          <p>
            3.2. The user has the right to revoke his consent to receive the Notifications:
            <ul>
              <li>by clicking on the &quot;Unsubscribe&quot; link at the bottom of the letter;</li>
              <li>by sending a notification to the Administrator&apos;s e-mail.</li>
            </ul>
          </p>
          <p>
            3.3. The User agrees that the Administrator stops sending the Notifications not earlier than 24
            hours after the performance of these actions.
          </p>
          <p>
            The administrator has the right to use the Notifications for:
            <ul>
              <li>informing the User about the operation of the Platform functions;</li>
              <li>informing the User about changes in regulatory documents;</li>
              <li>sending messages and mailings of informational character to the User;</li>
              <li>sending messages and mailings of an advertising nature to the User.</li>
            </ul>
          </p>
          <p>
            3.5. The User, in turn, undertakes to send all messages, notifications, statements and documents
            (including messages that represent responses to Notifications) to the Administrator&apos;s email
            address specified in this Policy.
          </p>
          <p>
            3.6. The Administrator has the right to request any document that, in the opinion of the
            Administrator, has legal significance, in its paper form. Such documents, as well as documents
            that the User himself considers necessary to send in paper form, are sent to the address of the
            Administrator&apos;s location specified in this Policy.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Changes to the Privacy Policy. Applicable Law.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            4.1. The administrator has the right to make changes to this Policy. When making changes, the date of the
            last update is
            indicated in the text of the current edition. The new edition of the Policy comes into legal effect from the
            moment
            it is posted, unless otherwise provided by the new edition of the Policy. Expired editions are available in
            the
            web-archive at the address specified in the Policy.
          </p>
          <p>
            4.2. Both expression of&nbsp;consent with this Policy and execution of&nbsp;this Policy shall be&nbsp;always considered happening 
            at&nbsp;the location of&nbsp;the Administrator, and the law applicable to&nbsp;the relationship between the Administrator and the User 
            is&nbsp;always the law of&nbsp;the location of&nbsp;the Administrator, regardless of&nbsp;where the User or&nbsp;the equipment used 
            by&nbsp;him or&nbsp;her is&nbsp;located. All disputes and disagreements are resolved at&nbsp;the location of&nbsp;the Administrator. 
            The exception is&nbsp;when the Parties&rsquo; legal relationship falls under the exterritorial criteria of&nbsp;the European General 
            Data Protection Regulation (&laquo;GDPR&raquo; or&nbsp;&laquo;(EU) 2016/679&raquo;). In&nbsp;such case, the law applicable to&nbsp;the 
            relationship between the Administrator and the User shall consist jointly of&nbsp;the law of&nbsp;the location of&nbsp;the Administrator 
            and the rules of&nbsp;the GDPR regulation, including the rules of&nbsp;solving disputes and disagreements between the participants 
            of&nbsp;personal data processing.
          </p>
          <p>
            4.3. The Policy begins to regulate the relationship between the User and the Administrator from the moment
            the User
            expresses consent to its terms and conditions and is valid indefinitely. The indefinite validity of the
            Policy as a
            document does not in any way mean the indefiniteness/absence of restrictions on the period for processing
            personal
            data. Unilateral termination of the Policy by the will of one of the Parties is not allowed.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Rules for Users located in the European Union.</SectionTitle>
        </li>
        <SectionContent>
          <p>
            5.1. In case You have allowed Your equipment to provide geolocation data, and from the contents
            of this data We can determine Your location within the European Union (EU), We are obliged to
            provide You with additional rights and guarantees in accordance with the European General Data
            Protection Regulation (&quot;GDPR&quot; or &quot;(EU) 2016/679&quot;), if the legal relationship
            of the Parties falls within its extraterritorial criteria.
          </p>
          <p>
            5.2. The User hereby acknowledges that the location of the User’s equipment that is transferring
            data to the Administrator shall be the only technically possible way to identify the User as an
            EU resident. If the User is using any means to cloak his or her location, or is using any means
            which may possibly cause such a cloaking, then the Administrator is not able to identify the
            User as a Party falling under the regulation of GDPR and therefore the relationship between the
            User and the Administrator shall not be liable to GDPR regulation.
          </p>
          <p>
            5.3. The relationship between the User and the Administrator shall fall under the GDPR
            regulation from the moment We identify Your location inside the EU and up to the moment We
            identify Your new location outside the EU.
          </p>
          <p>
            5.4. The core rights and guarantees of GDPR for individuals are the following:
            <ul>
              <li>the right to&nbsp;be&nbsp;informed;</li>
              <li>the right of&nbsp;access;</li>
              <li>the right to&nbsp;rectification;</li>
              <li>the right to&nbsp;erasure;</li>
              <li>the right to&nbsp;restrict processing;</li>
              <li>the right to&nbsp;data portability;</li>
              <li>the right to&nbsp;object;</li>
              <li>the rights related to&nbsp;automated decision making (including profiling).</li>
            </ul>
          </p>
          <p>
            5.5. In cases provided for by applicable law, the User may also have other rights and guarantees
            not specified above.
          </p>
          <p>
            5.6. To exercise the rights and guarantees, the User can use the appropriate functions of his
            account, and if the functions of the account are not sufficient in the opinion of the User, by
            sending a written request to the Administrator&apos;s e-mail address specified in this Policy.
          </p>
          <p>
            5.7. Should the Administrator use any kind of third-party data processor service to process
            personal data, he shall provide the data processor’s full compliance with GDPR and shall provide
            You with the requested information concerning such data processor.
          </p>
          <p>
            5.8. The User is fully aware and accepts the fact that the extension of GDPR rules to the
            relations of the Parties does not in any way entail and does not indicate the application of any
            other acts of European Union legislation to the relations of the Parties.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Edition information.</SectionTitle>
        </li>
        <SectionContent>
          <p>This edition of the document was published on: 2025, May, 5st</p>
        </SectionContent>
      </SectionsList>
    </>
  );
};
